const DEFAULT_CONFIG = {
	//接口地址
	API_URL: 'https://chaxun.ai-suguan.cn/api',
}

export default DEFAULT_CONFIG
